import Transform from 'images/key-capabilities/Transform.png';
import Stickers from 'images/key-capabilities/Stickers.png';
import Filters from 'images/key-capabilities/Filters.png';
import CustomizableUI from 'images/key-capabilities/CustomizableUI.png';
import Adjustment from 'images/key-capabilities/Adjustment.png';
import Brush from 'images/key-capabilities/Brush.png';
import Frames from 'images/key-capabilities/Frames.png';
import Focus from 'images/key-capabilities/Focus.png';
import Empty from 'images/key-capabilities/Empty.png';
import Toolbar from 'images/key-capabilities/Toolbar.png';
import pesdkImage1 from "../../../../.remote/gatsby-imgly-source/3da22cbf2aac60efa607bb2de361c0530787fd65/docs/shared/images/pesdk.png";
import pesdkImage2 from "../../../../.remote/gatsby-imgly-source/3da22cbf2aac60efa607bb2de361c0530787fd65/docs/shared/images/pesdk2.png";
import * as React from 'react';
export default {
  Transform,
  Stickers,
  Filters,
  CustomizableUI,
  Adjustment,
  Brush,
  Frames,
  Focus,
  Empty,
  Toolbar,
  pesdkImage1,
  pesdkImage2,
  React
};